import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectWorkingSession, selectWorkingSessionCaptionsEnabled } from '@/store/slices/project/selectors';
import Container from '@ui/container/container';
import SwitchV2 from '@ui/switch-v2/switch-v2';
import Text from '@ui/text/text/text';
import { saveWorkingProjectSessionByField } from '@/store/slices/project';

const EditSessionCaptions = () => {
  const dispatch = useAppDispatch();

  const session = useAppSelector(selectWorkingSession);
  const captionsEnabled = useAppSelector(selectWorkingSessionCaptionsEnabled);

  const handleToggle = () => {
    if (!session) return;
    const isOn = !!session.streaming_options?.auto_transcripts;

    dispatch(
      saveWorkingProjectSessionByField({
        uuid: session.uuid,
        streaming_options: {
          ...session.streaming_options,
          auto_transcripts: !isOn,
        },
      })
    );
  };

  return (
    <Container>
      <Container className="flex ai-center jc-space-between">
        <Text className="L3 padding-b-8">CAPTIONS</Text>
      </Container>
      <Container className="padding-t-4">
        <SwitchV2 on={captionsEnabled} onClick={handleToggle} value={captionsEnabled} onLabel="On" offLabel="Off" />
      </Container>
    </Container>
  );
};

export default EditSessionCaptions;
